import { Component, Prop, Vue } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import vSelect from 'vue-select'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrashAlt, faClose } from '@fortawesome/free-solid-svg-icons'

import { genId } from '@/helpers/gen-id'
import api from '@/helpers/fetch'
import Fuse from 'fuse.js'

library.add(faTrashAlt, faClose)
let chart
let rChart

@Component({
	components: {
		Loader,
		vSelect,
	},
})
export default class Calculator extends Vue {
	subscriptions = [] as Array<any>

	form = {
		msg: '{ "title": "teste", "options": { "body": "nova notificação" } }',
		id: [] as Array<any>,
	}

	get ids() {
		return this.subscriptions.map((item) => {
			return { label: `${item.id} ${item.user.name}`, value: item.id }
		})
	}

	async send() {
		const res = await api.post('/api/subscriptions', this.form)
	}

	fuseSearch(options, search) {
		const fuse = new Fuse(options, {
			keys: [],
			shouldSort: true,
			ignoreLocation: true,
		})
		// @ts-ignore
		return search.length
			? fuse.search(search).map(({ item }) => item)
			: options
	}

	async mounted() {
		const res = await api.get('/api/subscriptions')
		this.subscriptions.push(...res.data)
	}
}
